export enum PointOfSaleCategory {
  Ticket = "Ticket",
  Membership = "Membership",
  Booking = "Booking",
  AnnualPass = "AnnualPass",
  Cafe ="Cafe",
  Fee = "Fee"
}
